import {
  ADDRESS_ID,
  APPLYING_BONUS_NAME,
  OPTIONS_NAME,
  PAYMENT_NAME,
  PICKUP,
  RECEIPT_TYPE_NAME,
  TIME_SLOTS_NAME,
} from '@checkout/const';
import { CheckoutActions } from '../actions';
import { CustomCheckoutState } from '../checkout-state';

export const initialState: CustomCheckoutState['activeModes'] = {
  [RECEIPT_TYPE_NAME]: undefined,
  [PICKUP]: undefined,
  [PAYMENT_NAME]: undefined,
  [ADDRESS_ID]: undefined,
  [TIME_SLOTS_NAME]: undefined,
  [OPTIONS_NAME]: undefined,
  [APPLYING_BONUS_NAME]: undefined,
};

export function reducer(
  state = initialState,
  action:
    | CheckoutActions.CheckoutActions
    | CheckoutActions.ReceiptTypeActions
    | CheckoutActions.ApplyingBonusActions
    | CheckoutActions.SavedDeliveryAddressAction
    | CheckoutActions.ShopsActions
    | CheckoutActions.PaymentActions
    | CheckoutActions.TimeSlotsActions
    | CheckoutActions.OptionsActions,
): CustomCheckoutState['activeModes'] {
  switch (action.type) {
    case CheckoutActions.ACTIVE_MODE_RESET: {
      return initialState;
    }

    case CheckoutActions.SET_APPLYING_BONUS: {
      return {
        ...state,
        [APPLYING_BONUS_NAME]: action.payload,
      };
    }

    case CheckoutActions.RESET_APPLYING_BONUS: {
      return {
        ...state,
        [APPLYING_BONUS_NAME]: initialState[APPLYING_BONUS_NAME],
      };
    }

    case CheckoutActions.SET_ACTIVE_RECEIPT_TYPE: {
      return {
        ...state,
        [RECEIPT_TYPE_NAME]: action.payload,
      };
    }

    case CheckoutActions.SET_SHOP: {
      return {
        ...state,
        [PICKUP]: action.payload,
      };
    }

    case CheckoutActions.RESET_SHOP: {
      return {
        ...state,
        [PICKUP]: initialState[PICKUP],
      };
    }

    case CheckoutActions.SELECT_ACTIVE_DELIVERY_ADDRESS: {
      return {
        ...state,
        [ADDRESS_ID]: action.payload,
      };
    }

    case CheckoutActions.DELETE_SAVED_DELIVERY_ADDRESS: {
      const deletedId = action.payload as string;

      if (state[ADDRESS_ID] === deletedId) {
        return {
          ...state,
          [ADDRESS_ID]: undefined,
        };
      }

      return state;
    }

    case CheckoutActions.SET_PAYMENT: {
      return {
        ...state,
        [PAYMENT_NAME]: action.payload,
      };
    }

    case CheckoutActions.RESET_PAYMENT: {
      return {
        ...state,
        [PAYMENT_NAME]: initialState[PAYMENT_NAME],
      };
    }

    case CheckoutActions.SET_TIME_SLOTS: {
      return {
        ...state,
        [TIME_SLOTS_NAME]: action.payload,
      };
    }

    case CheckoutActions.RESET_TIME_SLOTS: {
      return {
        ...state,
        [TIME_SLOTS_NAME]: undefined,
      };
    }

    case CheckoutActions.SET_OPTIONS: {
      return {
        ...state,
        [OPTIONS_NAME]: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
